import React from 'react';
import { CtaButton } from './CtaButton';
import { ArchLines } from './ArchLines';
import { ProductStack } from './ProductStack';
const chips = ['6 Volumes', '84 Vivencia Plans', '5 Bonuses', '300 Pages', '18 Worksheets'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Works with your own music library'];

// Colores de las fases del arco (Intention, Rise, Deepen, Return)
const phases = ['bg-patrol-mustard', 'bg-ember', 'bg-moss', 'bg-patrol-teal', 'bg-patrol-plum'];
export function Hero() {
  return <section className="topo-dark relative w-full overflow-hidden border-b border-forest-line bg-forest-deep" data-id="element-124" data-mp="x8jndoipuui9">
      <ArchLines className="pointer-events-none absolute -right-16 -top-6 h-[360px] w-[360px] text-paper/[0.05] sm:h-[480px] sm:w-[480px]" data-id="element-125" data-mp="nc876ng09kij" />

      <div className="relative z-10 mx-auto max-w-6xl px-5 pb-14 pt-7 sm:pb-20 sm:pt-12" data-id="element-126" data-mp="3d2le7pgobt71">
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-127" data-mp="381e2xgfbobvm">
          <div data-id="element-128" data-mp="3j896tarbk7oh">
            <p className="eyebrow text-ember" data-id="element-129" data-mp="3j9k730lk2xau">
              For dance &amp; movement facilitators who hold a weekly circle
            </p>
            <h1 className="mt-3 font-display text-[34px] leading-[1.06] text-paper sm:text-5xl md:text-6xl" data-id="element-130" data-mp="3o5j1b4tkf9j6">
              Class is tomorrow.{' '}
              <span className="text-ember" data-id="element-131" data-mp="3e8mqgsg72bbg">The vivencia is already shaped.</span>
            </h1>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-paper/80 sm:text-lg" data-id="element-132" data-mp="30hreh7aefe3n">
              Vivencia Ready gives you 84 complete session plans — weekly
              classes, taster classes, themed workshops and a full weekend
              retreat — each on two pages you read once and run. Not another
              list of exercises: the whole class, from opening circle to
              closing circle, with every moment timed, the key cues written
              out and music guidance for each phase.{' '}
              <span className="font-semibold text-paper" data-id="element-133" data-mp="2lk8vymobdx4n">
                So you stop spending your evenings building next week’s class
                and keep your group coming back.
              </span>
            </p>
            <ul className="mt-5 flex flex-wrap gap-2" data-id="element-134" data-mp="n98djnya55nw">
              {chips.map(chip => <li key={chip} className="rounded-md border border-paper/25 bg-paper/10 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-paper/90" data-id="element-135" data-mp="ia5jeyju8jup">
                  {chip}
                </li>)}
            </ul>
          </div>

          <ProductStack data-id="element-136" data-mp="15zzv3csf82dd" />
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-137" data-mp="111yd6v6qe93h">
          <div className="w-full max-w-md" data-id="element-138" data-mp="114kieo65gcij">
            <CtaButton data-id="element-139" data-mp="x1wb4kx33dno">Get Vivencia Ready</CtaButton>
          </div>

          <div className="mt-5 flex max-w-md flex-col items-center gap-2.5 text-center sm:flex-row sm:text-left" data-id="element-140" data-mp="3lsypkqaae6eu">
            <ul className="flex -space-x-1.5" aria-hidden="true" data-id="element-141" data-mp="3hqu0m4us9xyj">
              {phases.map(color => <li key={color} className={`h-7 w-7 rounded-full border-2 border-forest-deep ${color}`} data-id="element-142" data-mp="1xa43fdhjeij3" />)}
            </ul>
            <p className="text-[13px] leading-snug text-paper/70" data-id="element-143" data-mp="269hc43xu732r">
              Built for facilitators who run weekly groups, taster classes,
              workshops and retreats — in the US, UK, Canada and Australia.
            </p>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-paper/65" data-id="element-144" data-mp="2fzj436tb95my">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-145" data-mp="2p0qpwpen4e05">
                <span className="h-1.5 w-1.5 rounded-full bg-ember" data-id="element-146" data-mp="2oye6s8x5bxli" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}